<template>
    <div class="invite-detail">
        <div class="header">
            <div class="header-left">
                <button class="back-btn" @click="goBack">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="title">我的邀请</div>
            </div>
        </div>

        <div style="background: #fff;border-radius: 8px;">
            <div ref="chart" class="chart-wrapper" style="height:240px;width:100%"></div>
        </div>

        <div style="background: #fff;padding:0px 10px 10px 10px;margin-top: 10px;border-radius: 8px;">
            <el-table :data="tableData" stripe style="width:100%" height="calc(100vh - 335px)">
                <el-table-column prop="date" label="日期" width="140" />
                <el-table-column prop="orderCount" label="订单数" width="120" />
                <el-table-column prop="commission" label="佣金" width="140">
                    <template slot-scope="scope">
                        {{ formatCurrency(scope.row.commission) }}
                    </template>
                </el-table-column>
            </el-table>
        </div>

    </div>
</template>

<script>
import * as echarts from 'echarts/dist/echarts'
import { getInviteDetailByPositionId } from '@/utils/jdApi'

export default {
    name: 'InviteDetail',
    data() {
        return {
            positionId: '',
            chartInstance: null,
            tableData: [],
            loading: false
        }
    },
    activated() {
        this.positionId = this.$route.params.positionId || ''
        this.loadData()
        window.addEventListener('resize', this.resizeChart)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeChart)
        if (this.chartInstance) this.chartInstance.dispose()
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        async loadData() {
            if (!this.positionId) return
            this.loading = true
            try {
                // 如果路由传入 'admin'，后端约定使用 0 表示所有推广位
                const paramPositionId = this.positionId === 'admin' ? '0' : this.positionId
                const resp = await getInviteDetailByPositionId(paramPositionId, 30)
                if (resp && resp.success) {
                    const payload = resp.data || {}
                    this.tableData = payload.tableList || []
                    this.renderChart(this.tableData)
                } else {
                    this.$message.error('获取邀请详情失败')
                }
            } catch (e) {
                console.error(e)
                // 如果是权限错误（403），显示友好提示
                if (e.response && e.response.status === 403) {
                    const msg = '没有权限查看该推广位的详情'
                    this.$message.warning(msg)
                } else {
                    this.$message.error('获取邀请详情失败')
                }
            } finally {
                this.loading = false
            }
        },
        renderChart(list) {
            // 准备数据，若无数据则回退到最近 30 天
            let dates = list.map(i => i.date)
            let orders = list.map(i => i.orderCount)
            let commissions = list.map(i => Number((i.commission || 0)))

            if (!dates || dates.length === 0) {
                const days = 30
                const dtf = new Date()
                dates = []
                orders = []
                commissions = []
                for (let i = days - 1; i >= 0; i--) {
                    const d = new Date()
                    d.setDate(dtf.getDate() - i)
                    const yyyy = d.getFullYear()
                    const mm = (d.getMonth() + 1).toString().padStart(2, '0')
                    const dd = d.getDate().toString().padStart(2, '0')
                    dates.push(`${yyyy}-${mm}-${dd}`)
                    orders.push(0)
                    commissions.push(0)
                }
            }

            try {
                if (!this.chartInstance) this.chartInstance = echarts.init(this.$refs.chart)
                const option = {
                    color: ['#42b983', '#ff6b35'], // 订单数, 佣金
                    tooltip: { trigger: 'axis' },
                    legend: {
                        data: [
                            { name: '订单', itemStyle: { opacity: 0 } },
                            { name: '佣金', itemStyle: { opacity: 0 } }
                        ],
                    },
                    grid: { left: '10px', right: '15px', top: '25px', bottom: '5px', containLabel: true },
                    xAxis: [{ type: 'category', data: dates, boundaryGap: false }],
                    yAxis: { type: 'value', name: '' },
                    series: [
                        {
                            name: '订单',
                            type: 'line',
                            data: orders,
                            xAxisIndex: 0,
                            showSymbol: false,
                            lineStyle: { color: '#42b983' },
                            itemStyle: { color: '#42b983' }
                        },
                        {
                            name: '佣金',
                            type: 'line',
                            data: commissions,
                            xAxisIndex: 0,
                            showSymbol: false,
                            lineStyle: { color: '#ff6b35' },
                            itemStyle: { color: '#ff6b35' }
                        }
                    ]
                }
                this.chartInstance.setOption(option)
            } catch (e) {
                console.error('渲染图表失败', e)
            }
        },
        resizeChart() {
            if (this.chartInstance) this.chartInstance.resize()
        },
        formatCurrency(v) {
            if (v === null || v === undefined) return '0.00'
            return Number(v).toFixed(2)
        }
    }
}
</script>

<style scoped lang="scss">
.invite-detail {
    height: 100vh;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 10px;
    box-sizing: border-box;
}

.header {
    background: linear-gradient(135deg, #42b983, #369870);
    color: white;
    padding: 4px;
    margin-bottom: 10px;
    flex-shrink: 0;
    border-radius: 12px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.back-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    color: white;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
    width: 20px;
    height: 20px;
}

.title {
    font-size: 16px;
    font-weight: 600;
    color: white;
}

.chart-wrapper {
    width: 100%;
    height: 100%;
    padding: 0px;
    margin: 0;
    box-sizing: border-box;
    line-height: 0;
    /* 避免子元素基线造成空隙 */
}
</style>
